module.exports = __webpack_public_path__ + "russo-one-v8-latin-regular.woff2?2abd4c6ea036115375af64e67197359b";